import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

import SEO from '../components/SEO'
import HeroWithImage from '../components/shared/HeroWithImage'

import BeforePreFooter from '../components/shared/BeforePreFooter'
import QueensPage from '../components/QueensPage'
import i18n from '../../config/i18n'

const Queens = ({ data: { queens }, pageContext: { locale }, location }) => {
  const { data } = queens
  const {
    hero_title: heroTitle,
    hero_image: heroImage,
    final_section_title: title,
    final_section_description: description,
    final_section_link_text: linkText,
    final_section_link_url: url,
    final_section_image: image,
  } = data

  return (
    <>
      <SEO pathname={location.pathname} locale={locale} banner={heroImage.url} title={i18n[locale].seo.queens.title} />
      <HeroWithImage src={heroImage.url} title={heroTitle} />
      <QueensPage data={data} />
      <BeforePreFooter title={title} description={description} linkText={linkText} url={url} image={image.url} />
    </>
  )
}

export default Queens

Queens.propTypes = {
  data: PropTypes.shape({
    queens: PropTypes.object.isRequired,
  }).isRequired,
  pageContext: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
  location: PropTypes.object.isRequired,
}

export const pageQuery = graphql`
  query queensQuery($locale: String!) {
    queens: prismicQueensPage(lang: { eq: $locale }) {
      data {
        hero_title
        hero_image {
          url
        }
        main_title
        main_text {
          html
        }
        queens_group {
          queen {
            document {
              data {
                image {
                  url
                }
                name
                description
                date_of_birth
                origin
                hcm_certificate {
                  url
                }
                pedigree {
                  url
                }
                fiv_felv_certificate {
                  url
                }
              }
            }
          }
        }
        final_section_title
        final_section_image {
          url
        }
        final_section_link_url
        final_section_link_text
        final_section_description
      }
    }
  }
`
